import {
  AppContext,
  Asset,
  Clients,
  Close,
  ContractTemplate,
  Invoice,
  Quotes,
  InvoiceAudit,
  Project,
  Ticket,
  Task,
  Script,
  Alert,
  Patch,
  Reports,
  Charts,
  AccessControl,
  isAuthorised,
  ItDocumantation,
  UnkownEmail,
  ModuleLogo,
  getTranslatedText
} from '@nile/components';
import { injectIntl, useIntl, FormattedMessage } from 'react-intl';
import { HomeContext } from '@nile/mangifera/src/Contexts';
import { Module } from '@nile/mangifera/src/Pebbles/AppHomePage';
import { getTabTemplate } from '@nile/mangifera/src/Pebbles/TabManager';
import { cloneDeep } from 'lodash';
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { TaskAlt } from '@styled-icons/material-rounded';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { Button } from '@superops/ui-design-system';

function ModulesPage(props) {
  const intl = useIntl();
  const { flags } = props;
  const appContext = useContext(AppContext);
  const homeContext = useContext(HomeContext);
  const { user } = appContext;
  const browser = homeContext.getBrowserType();

  const handleModuleNavigation = (mod) => {
    const currentAppState = homeContext?.userAppState || { appState: [] };
    const updatedAppState = cloneDeep(currentAppState.appState);
    let tab = null;
    let tabIdx = null;
    switch (mod.name) {
      case 'CLIENTS':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
        tab = {
          id: 'client',
          content: getTabTemplate({ module: 'ALL_CLIENTS' }),
          accessibilityLabel: 'Client tab',
          module: 'ALL_CLIENTS',
          tabId: 2,
          state: {},
          data: {},
          url: '/clientViews/3001/client-list'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'ASSETS':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'rmm-home');
        tab = {
          id: 'rmm-home',
          content: getTabTemplate({ module: 'RMM_HOME' }),
          accessibilityLabel: 'Client tab',
          module: 'RMM_HOME',
          tabId: 3,
          state: {},
          data: {},
          url: '/rmm/asset-view/4001'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'ITDOC':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'itDocs');
        tab = {
          id: 'itDocs',
          content: getTabTemplate({ module: 'IT_DOCS' }),
          accessibilityLabel: 'Client tab',
          module: 'IT_DOCS',
          state: {},
          data: {},
          url: '/rmm/itdoc/Password&&1001'
        };
        //This fix is added for backward compatibility when existing assets tab have
        //IT docs section opened and this will become obsolete after tabs are refreshed
        const dupTab = updatedAppState.findIndex((el) => el.url === tab.url);
        if (dupTab > -1) {
          updatedAppState[dupTab].url = '/rmm/patch/1001';
        }
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'PATCHES':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'rmm-home');
        tab = {
          id: 'rmm-home',
          content: getTabTemplate({ module: 'RMM_HOME' }),
          accessibilityLabel: 'Client tab',
          module: 'RMM_HOME',
          tabId: 3,
          state: {},
          data: {},
          url: '/rmm/patch/1001'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'ALERTS':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'rmm-home');
        tab = {
          id: 'rmm-home',
          content: getTabTemplate({ module: 'RMM_HOME' }),
          accessibilityLabel: 'Client tab',
          module: 'RMM_HOME',
          tabId: 3,
          state: {},
          data: {},
          url: '/rmm/alert/1013'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'SCRIPTS':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'rmm-home');
        tab = {
          id: 'rmm-home',
          content: getTabTemplate({ module: 'RMM_HOME' }),
          accessibilityLabel: 'Client tab',
          module: 'RMM_HOME',
          tabId: 3,
          state: {},
          data: {},
          url: '/rmm/script/1011'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'COMMUNITY_SCRIPTS':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'script-library');
        tab = {
          id: 'script-library',
          content: getTabTemplate({ module: 'SCRIPTS_HOME' }),
          accessibilityLabel: 'Script library',
          module: 'SCRIPTS_HOME',
          tabId: 'script-library-tab',
          state: {},
          data: {},
          url: '/rmm/scripts-library/scripts/1011'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'REPORTS':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'reports-charts');
        tab = {
          id: 'reports-charts',
          content: getTabTemplate({
            module: 'REPORTS_CHARTS_HOME',
            data: { title: getTranslatedText(intl, 'reports.dashboard.title') }
          }),
          accessibilityLabel: 'Client tab',
          module: 'REPORTS_CHARTS_HOME',
          tabId: 11,
          state: {},
          data: {},
          url: '/report/1/view'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'CHARTS':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'reports-charts');
        tab = {
          id: 'reports-charts',
          content: getTabTemplate({
            module: 'REPORTS_CHARTS_HOME',
            data: { title: getTranslatedText(intl, 'reports.dashboard.title') }
          }),
          accessibilityLabel: 'Client tab',
          module: 'REPORTS_CHARTS_HOME',
          tabId: 11,
          state: {},
          data: {},
          url: '/charts/2001/All Charts'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'PROJECTS':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'workspace');
        tab = {
          id: 'workspace',
          content: getTabTemplate({ module: 'WORKSPACE' }),
          accessibilityLabel: 'My workspace',
          module: 'WORKSPACE',
          tabId: 6,
          state: {},
          data: {},
          url: '/project/6/Active Projects'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'TASKS':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'workspace');
        tab = {
          id: 'workspace',
          content: getTabTemplate({ module: 'WORKSPACE' }),
          accessibilityLabel: 'My workspace',
          module: 'WORKSPACE',
          tabId: 8,
          state: {},
          data: {},
          url: '/tasks/3/task-list'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'UNKNOWN_EMAILS':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
        tab = {
          id: 'client',
          content: getTabTemplate({ module: 'ALL_CLIENTS' }),
          accessibilityLabel: 'Client tab',
          module: 'ALL_CLIENTS',
          tabId: 2,
          state: {},
          data: {},
          url: '/mailBoxViews/5006/Unknown Emails'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'ALL CONTRACTS':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
        tab = {
          id: 'client',
          content: getTabTemplate({ module: 'ALL_CLIENTS' }),
          accessibilityLabel: 'Client tab',
          module: 'ALL_CLIENTS',
          tabId: 2,
          state: {},
          data: {},
          url: '/contractViews/1/All contracts'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'CONTRACT TEMPLATE':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
        tab = {
          id: 'client',
          content: getTabTemplate({ module: 'ALL_CLIENTS' }),
          accessibilityLabel: 'Client tab',
          module: 'ALL_CLIENTS',
          tabId: 2,
          state: {},
          data: {},
          url: '/contractViews/1/Contracts'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'QUOTES':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
        tab = {
          id: 'client',
          content: getTabTemplate({ module: 'ALL_CLIENTS' }),
          accessibilityLabel: 'Client tab',
          module: 'ALL_CLIENTS',
          tabId: 2,
          state: {},
          data: {},
          url: '/quoteViews/24/All Quotes'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'INVOICE':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
        tab = {
          id: 'client',
          content: getTabTemplate({ module: 'ALL_CLIENTS' }),
          accessibilityLabel: 'Client tab',
          module: 'ALL_CLIENTS',
          tabId: 2,
          state: {},
          data: {},
          url: '/invoiceViews/32/invoice-list'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'INVOICE AUDIT':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
        tab = {
          id: 'client',
          content: getTabTemplate({ module: 'ALL_CLIENTS' }),
          accessibilityLabel: 'Client tab',
          module: 'ALL_CLIENTS',
          tabId: 2,
          state: {},
          data: {},
          url: '/invoiceAuditViews/101/Invoice audit'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'SALES_INBOX':
        tabIdx = updatedAppState.findIndex((el) => el.id === 'client');
        tab = {
          id: 'client',
          content: getTabTemplate({ module: 'ALL_CLIENTS' }),
          accessibilityLabel: 'Client tab',
          module: 'ALL_CLIENTS',
          tabId: 2,
          state: {},
          data: {},
          url: '/mailBoxViews/5004/All Conversations'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
        break;
      case 'WORKSPACE':
      default:
        tabIdx = updatedAppState.findIndex((el) => el.id === 'workspace');
        tab = {
          id: 'workspace',
          content: getTabTemplate({ module: 'WORKSPACE' }),
          accessibilityLabel: 'My workspace',
          module: 'WORKSPACE',
          tabId: 8,
          state: {},
          data: {},
          url: '/ticket/1/ticket-list'
        };
        if (tabIdx === -1) {
          updatedAppState.push(tab);
        } else {
          updatedAppState[tabIdx] = tab;
        }
    }
    homeContext.updateUserAppState({
      ...currentAppState,
      appState: updatedAppState,
      activeTabIndex: updatedAppState.findIndex((el) => el.id === tab.id)
    });
    homeContext.closeModulesOverlay(true);
    setTimeout(() => {
      homeContext.switchTabFocus(tab);
    }, 200);
  };
  const greetText = 'Good day';
  const myWorkList = [
    {
      name: 'WORKSPACE',
      label: 'app.modules.workspace.ticket',
      icon: <Ticket />
    },
    {
      name: 'TASKS',
      label: 'app.modules.workspace.task',
      icon: <Task />
    },
    {
      name: 'PROJECTS',
      label: 'app.modules.workspace.project',
      icon: <Project />,
      ldFlag: 'projectManagement',
      authorisation: 'project'
    }
  ];
  const assetManagement = [
    {
      name: 'ASSETS',
      label: 'ticket.details.insights.assets',
      icon: <Asset />
    },
    {
      name: 'ALERTS',
      label: 'app.modules.asset.alert',
      icon: <Alert />
    },
    {
      name: 'PATCHES',
      label: 'app.modules.asset.patch',
      icon: <Patch />
    },
    {
      name: 'SCRIPTS',
      label: 'app.modules.asset.script',
      icon: <Script />,
      ldFlag: '!communityScript'
    },
    {
      name: 'COMMUNITY_SCRIPTS',
      label: 'app.modules.asset.script',
      icon: <Script />,
      ldFlag: 'communityScript'
    }
  ];

  const clientManagement = [
    {
      name: 'CLIENTS',
      label: 'client.mainpage.header',
      icon: <Clients />,
      authorisation: 'client'
    },
    {
      name: 'CONTRACT TEMPLATE',
      label: 'app.modules.workspace.contractTemplate',
      icon: <ContractTemplate />,
      authorisation: 'contractTemplate'
    },
    {
      name: 'INVOICE AUDIT',
      label: 'invoiceViews.invoiceAudit.label',
      icon: <InvoiceAudit />,
      authorisation: 'invoice'
    },
    {
      name: 'INVOICE',
      label: 'invoiceViews.navigation.header',
      icon: <Invoice />,
      authorisation: 'invoice'
    },
    {
      name: 'SALES_INBOX',
      label: 'client.views.salesInbox',
      icon: <ModuleLogo image="mailbox.svg" />,
      authorisation: 'clientConversation',
      operation: 'view'
    },
    {
      name: 'QUOTES',
      label: 'quoteViews.navigation.header',
      icon: <Quotes />,
      authorisation: 'invoice', // TODO-QUOTE: Change to quote
      flag: 'quote'
    }
    // {
    //   name: 'UNKNOWN_EMAILS',
    //   label: 'app.modules.workspace.unknownEmails',
    //   icon: <UnkownEmail />,
    //   authorisation: 'client'
    // }
  ];

  const reportsAndCharts = [
    {
      name: 'ITDOC',
      label: 'asset.sidebar.ITdoc',
      icon: <ItDocumantation />,
      ldFlag: 'itDocumentation'
    },
    {
      name: 'REPORTS',
      label: 'reports.stepnavi.dashboard.title',
      icon: <Reports />,
      ldFlag: 'reports',
      authorisation: 'report'
    }
    // {
    //   name: 'CHARTS',
    //   label: 'app.modules.charts.title',
    //   icon: <Charts />,
    //   ldFlag: 'charts',
    //   authorisation: 'report'
    // }
  ];

  const reference = appContext.user?.role?.roleFeatureList || [];
  const authorisedWorkSpace = myWorkList.filter((el) => {
    if (!el.ldFlag) return true;
    const isFeatureAuthorised = isAuthorised(
      reference,
      `${el.authorisation}.view`
    );
    const isShowFeature = el.ldFlag && flags[el.ldFlag] && isFeatureAuthorised;
    return isShowFeature;
  });
  const authorisedClientManagement = clientManagement.filter((el) => {
    if (!el.name) return true;
    if (el.flag && !flags?.[el.flag]) return false;
    const isFeatureAuthorised = isAuthorised(
      reference,
      `${el.authorisation}.${el.operation ? el.operation : 'view'}`
    );
    return isFeatureAuthorised;
  });

  const authorisedReportsAndCharts = reportsAndCharts.filter((el) => {
    if (!el.authorisation) return true;
    const isFeatureAuthorised = el.ldFlag
      ? isAuthorised(reference, `${el.authorisation}.view`) && flags[el.ldFlag]
      : isAuthorised(reference, `${el.authorisation}.view`);
    return isFeatureAuthorised;
  });

  const authorisedAssetManagement = assetManagement.filter((el) => {
    if (!el.ldFlag) return true;
    const isShowFeature = el.ldFlag && flags[el.ldFlag];
    return isShowFeature;
  });
  return (
    <HomeScreen browser={browser} className="sops-overlay-wrap">
      <Header className="sops-overlay-header">
        <Greeting className="sops-greating-text">Modules</Greeting>
        <Actions>
          <Button
            onClick={() => {
              homeContext.closeModulesOverlay(true);
            }}
            plain
          >
            <Close />
          </Button>
        </Actions>
      </Header>
      <SopsModuleWrap className="sops-module-wrap-height">
        <SopsInnerWrap className="sops-module-wrap">
          <ModuleSub className="sops-sub-head">
            <FormattedMessage id="app.modules.workspace" />
          </ModuleSub>
          <Modules className="sops-sec-wrap">
            {authorisedWorkSpace.map((el, i) => {
              return (
                <Module
                  onClick={handleModuleNavigation.bind(this, el)}
                  module={el}
                  index={i}
                />
              );
            })}
          </Modules>
          {flags?.assetsManagement && (
            <>
              <ModuleSub className="sops-sub-head">
                <FormattedMessage id="app.modules.asset" />
              </ModuleSub>
              <Modules className="sops-sec-wrap">
                {authorisedAssetManagement.map((el, i) => {
                  return (
                    <Module
                      onClick={handleModuleNavigation.bind(this, el)}
                      module={el}
                      index={i}
                    />
                  );
                })}
              </Modules>
            </>
          )}
          {authorisedClientManagement?.length > 0 && (
            <ModuleSub className="sops-sub-head">
              <FormattedMessage id="app.modules.client" />
            </ModuleSub>
          )}
          <Modules className="sops-sec-wrap">
            {authorisedClientManagement.map((el, i) => {
              return (
                <Module
                  onClick={handleModuleNavigation.bind(this, el)}
                  module={el}
                  index={i}
                />
              );
            })}
          </Modules>
          {authorisedReportsAndCharts?.length > 0 && (
            <ModuleSub className="sops-sub-head">
              <FormattedMessage id="modules.category.others" />
            </ModuleSub>
          )}
          <Modules className="sops-sec-wrap">
            {authorisedReportsAndCharts.map((el, i) => {
              return (
                <Module
                  onClick={handleModuleNavigation.bind(this, el)}
                  module={el}
                  index={i}
                />
              );
            })}
          </Modules>
        </SopsInnerWrap>
      </SopsModuleWrap>
    </HomeScreen>
  );
}

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  padding-left: 40px;
  padding-right: 40px;
`;

const Actions = styled.div`
  margin-left: auto;
  display: flex;
  button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ffffff33;
    span,
    span svg {
      width: 20px;
      height: 20px;
    }
    &:hover {
      background-color: #ffffff;
    }
  }
`;

const HomeScreen = styled.div`
  background: ${(props) =>
    props.browser === 'Mozilla Firefox'
      ? '#ececec'
      : 'radial-gradient(115.28% 115.28% at 26.48% -11.94%, rgba(252, 252, 255, 0.8) 0%,rgba(125, 125, 155, 0.04) 100%)'};
  backdrop-filter: blur(80px);
  padding: 20px 0px;
  height: 100vh;
  .module-logo {
    height: 56px;
    width: 64px;
  }
`;
const Greeting = styled.div`
  line-height: 63px;
  font-weight: normal;
  font-size: 30px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
`;
const ModuleSub = styled.div`
  line-height: 30px;
  font-weight: 400;
  font-size: 20px;
  padding: 0 10px;
`;
const Modules = styled.div`
  padding: 10px 10px 40px;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const SopsModuleWrap = styled.div`
  width: 100%;
  overflow-y: auto;
  height: calc(100vh - 160px);
`;

const SopsInnerWrap = styled.div`
  width: 800px;
  margin: 0 auto;
`;
export default withRouter(withLDConsumer()(injectIntl(ModulesPage)));
